import { Helmet } from "react-helmet-async"
import { PGPaymentLinks } from "../../../../Integrations"

export default function PGPaymentLinksPage() {
	return (
		<>
			<Helmet title="PG Payment Links" />
			<PGPaymentLinks />
		</>
	)
}
